import * as React from 'react';
type Props = {
  className?: string;
};
export function Feeds1({ className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-testid="illustrated-Feeds 1"
      className={className}
    >
      <title>Feeds 1</title>
      <g
        id="Feeds-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Group-12"
          transform="translate(4.000000, 3.000000)"
          stroke="currentColor"
        >
          <path
            d="M12.3190217,14.9635748 C18.9459298,14.9635748 24.3389746,19.4561445 24.6380435,25.089425 L24.6380435,25.089425 L4.15665481e-13,25.089425 C0.299068848,19.4561445 5.69211365,14.9635748 12.3190217,14.9635748 Z M12.3191852,-7.73884892e-13 C16.4505843,-7.72872992e-13 19.8008091,3.3502248 19.8008091,7.48162397 C19.8008091,11.6130231 16.4505843,14.9632479 12.3191852,14.9632479 C8.18615173,14.9632479 4.83756119,11.6130231 4.83756119,7.48162397 C4.83756119,3.3502248 8.18615173,-7.74897194e-13 12.3191852,-7.73884892e-13 Z M8.50957099,9.80717026 C9.38062944,11.2077276 10.9184643,12.0428325 12.5363778,11.9839992 C14.7736742,11.9039207 16.0026348,10.156901 16.1284725,9.97059586"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  );
}
